export default __webpack_public_path__ + "static/media/customer-2.f0ca442c.png";